// Globals
import { useTranslation } from 'react-i18next';

// Components
import { Form, FormItem, IFormInstance } from '@/components';
import { Checkbox, Input, TextArea } from '@/ui';
import { StyledInputs, StyledWrapper } from './RequiredDocumentFormStyles';

// Models
import { SupportedLanguages } from '@/models/localization.model';

// Helpers
import { RequiredDocumentFormValues, TRequiredDocumentFormValues } from '../../helpers';
import { useGetRequiredDocumentRules } from '../../hooks';

type TRequiredDocumentFormProps = {
  initialValues?: Partial<TRequiredDocumentFormValues>;
  onSubmit?: (values: TRequiredDocumentFormValues) => void;
  formInstance?: IFormInstance;
};

const RequiredDocumentForm = ({ initialValues, onSubmit, formInstance }: TRequiredDocumentFormProps) => {
  const rules = useGetRequiredDocumentRules();
  const { t } = useTranslation(['documents']);

  return (
    <Form initialValues={initialValues} onFinish={onSubmit} form={formInstance}>
      <StyledWrapper>
        {Object.values(SupportedLanguages).map((lang) => (
          <StyledInputs key={lang}>
            <FormItem
              name={`${RequiredDocumentFormValues.NAME}_${lang}`}
              rules={rules[RequiredDocumentFormValues.NAME_EN]}
              label={t('document_name', {
                context: lang,
              })}
            >
              <Input />
            </FormItem>
            <FormItem
              name={`${RequiredDocumentFormValues.DESCRIPTION}_${lang}`}
              rules={rules[RequiredDocumentFormValues.DESCRIPTION_EN]}
              label={t('document_description', {
                context: lang,
              })}
            >
              <TextArea autoSize={{ minRows: 4, maxRows: 4 }} />
            </FormItem>
          </StyledInputs>
        ))}
        <FormItem name={RequiredDocumentFormValues.IS_REQUIRED} valuePropName="checked">
          <Checkbox placeholder={t('document_required')} />
        </FormItem>
      </StyledWrapper>
    </Form>
  );
};

export default RequiredDocumentForm;
